import { AgentActionType } from 'entities/AgentActions'
import {
  type IAgentActionItem,
  type IAgentActionsConfig,
  ActionMessage,
  ActionNote,
  makeActionTags,
} from 'widgets/AgentActions'

export const CHATBOT_ACTION_ITEMS: IAgentActionItem[] = [
  { id: AgentActionType.AddTag, label: 'Add tag', iconL: 'tag' },
  { id: AgentActionType.RemoveTag, label: 'Remove tag', iconL: 'tag' },
  { id: AgentActionType.SendMessage, label: 'Send message', iconL: 'messageTextCircle02' },
  { id: AgentActionType.ContactNote, label: 'Add contact note', iconL: 'edit' },
]

export const CHATBOT_ACTIONS_CONFIG: IAgentActionsConfig = {
  [AgentActionType.AddTag]: {
    icon: 'tag',
    title: 'Add tag',
    Component: makeActionTags({ canCreate: true, placeholder: 'Search or create' }),
  },
  [AgentActionType.RemoveTag]: {
    icon: 'tag',
    title: 'Remove tag',
    Component: makeActionTags({ canCreate: false, placeholder: 'Search' }),
  },
  [AgentActionType.ContactNote]: {
    icon: 'edit',
    title: 'Contact note',
    Component: ActionNote,
  },
  [AgentActionType.SendMessage]: {
    icon: 'messageTextCircle02',
    title: 'Send message',
    Component: ActionMessage,
  },
}
